import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=2a010be9"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a010be9')) {
      api.createRecord('2a010be9', component.options)
    } else {
      api.reload('2a010be9', component.options)
    }
    module.hot.accept("./UserIcon.vue?vue&type=template&id=2a010be9", function () {
      api.rerender('2a010be9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/UserIcon.vue"
export default component.exports